import classes from '@/components/Shares/Button.module.css';
import { Button, Group, Stack, Text } from '@mantine/core';
import { IconClockFilled } from '@tabler/icons-react';
export type AvailableButtonProps = {
  status: 'available' | 'unavailable';
  time: string;
};
export const AvailableButton: React.FC<AvailableButtonProps> = ({
  status,
  time
}) => {
  return <Button fz={11} fw={700} h={52} className={classes.root}>
      <Stack gap={0} align="center">
        <Text fz="xs" fw={700} tt="uppercase">
          {status}
        </Text>
        <Group gap={4}>
          <IconClockFilled size={13} />
          <Text fz={11} fw={700}>
            {time}
          </Text>
        </Group>
      </Stack>
    </Button>;
};